import React from "react";
import { Row, Col } from "react-flexbox-grid";
import "./work.scss";
// Components
import TeamInfo from "./teamInfo";
import Title from "../ui-components/title/title";


const work = () => (
  <div id="work">
    <div className="wrapper">
      <Title title="WORK EXPERIENCE" />
      <Row>
      <Col md={12} lg={4}>
        <TeamInfo degree="Teaching Assistant" 
        institution="North South University" years="Jan 2023 - June 2023"  description="Teaching assistant for Object-Oriented Programming with Java and Software Engineering course for 3rd and 4th year undergraduate students, assigned to 5 different sections with over 150 students. Helping students with core object oriented concepts and assisting them with environment setup, projects, git, design patterns and other related technical topics. Creating, grading assignments and proctoring quizzes."/>
        
        </Col>
        <Col md={12} lg={4}>
        <TeamInfo degree="Uber Eats Campus Ambassador" 
        institution="Uber Eats Bangladesh" years="Feb 2020 - Mar 2020"  description="Selected from a pool of around 200 applicants from different universities, I promoted Uber Eats food delivery service on-campus and created buzz among youth. Through promo-codes and different digital marketing tactics of my own, I was the candidate who drove the second highest number of orders."/>
        
        </Col>
        
        <Col md={12} lg={4}>
          
          <TeamInfo degree="Freelance tutor"  years="2017-present" 
         description="I have been teaching a range of subjects to highschool students and have been able to help them improve their academic results significantly"/>
        </Col>
    
      </Row>
      
    </div>
  </div>
);

export default work;
